import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListConfirmedAtCell } from './emsp-bo-rfid-badge-order-list-confirmed-at.cell';
import { EmspBoRfidBadgeOrderListConfirmedAtHeader } from './emsp-bo-rfid-badge-order-list-confirmed-at.header';

export const EmspBoRfidBadgeOrderListConfirmedAtColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['confirmedAt']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListConfirmedAtHeader,
  cell: EmspBoRfidBadgeOrderListConfirmedAtCell,
};
